export interface SelectableAddress {
  id: string;
  type: AddressType;
  shortname: string;
  name: string;
}

export enum AddressType {
  COUNTRY = "COUNTRY",
  COUNTY = "COUNTY"
}
